jQuery.fn.customInput = function () {
    $(this).each(function (i) {
        if ($(this).is('[type=radio]')) {
            var input = $(this);
           if(input.data('sqlname') && input.data('sqlname') !== "" ){
            // get the associated label using the input's id
            var label = $('label[for=' + input.attr('id') + ']');

            //get type, for classname suffix
            var inputType = 'radio';

            // wrap the input + label in a div
            //$('').insertBefore(input).append(input, label);

            // find all inputs in this set using the shared name attribute
            var allInputs = $('input[name=' + input.data('sqlname') + ']');
            

            // necessary for browsers that don't support the :hover pseudo class on labels
            label.hover(
                function () {
                    $(this).addClass('hover');
                },
                function () { $(this).removeClass('hover'); }
            );

            //bind custom event, trigger it, bind click,focus,blur events
            input.bind('updateState', function (evt) {
                if (label.hasClass("checked")) {
                    $(evt.target).prop("checked", false);
                    label.removeClass('checked');
                    $(this).trigger('change');
                }
                else {
                    if (input.is(':checked')) {
                        if (input.is(':radio')) {
                            allInputs.each(function () {
                                $(this).next("label").removeClass('checked');
                                $(this).next("label").attr('aria-checked', 'false');
                            });
                        };
                        label.addClass('checked');
                        label.attr('aria-checked', 'true');
                    }
                    else { label.removeClass('checked'); }
                }

            })
            .trigger('updateState')
            .click(function (evt) {
                $(this).trigger('updateState');
            })
            .focus(function (evt) {
                label.addClass('focus');
            })
            .blur(function () { label.removeClass('focus'); });
        }}
    });
};
